import * as React from 'react';
import './RegisterPage.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../api/client';
import OAuthButton from '../components/OAuthButton';
import config from '../config';
import OrDivider from '../components/OrDivider';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    try {
      const resp = await apiRequest<{ token: string; user: any }>('/register', {
        method: 'POST',
        body: JSON.stringify({ name, email, password }),
      });

      localStorage.setItem('authToken', resp.token);
      localStorage.setItem('user', JSON.stringify(resp.user));

      navigate('/choose-plan');
    } catch (err: any) {
      setError(err.message || 'Registration failed');
    }
  };

  return (
    <div className="centered-page">
      <div className='support-stack'>
        <div className="centered-card fade-in">
          <form className="register-form" onSubmit={handleSubmit}>
            <h2>Register Account</h2>
            {error && <p className="error-message">{error}</p>}

            <input
              type="text"
              id="name"
              placeholder="Your Name"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />

            <input
              type="email"
              id="email"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />

            <input
              type="password"
              id="confirm-password"
              placeholder="Confirm Password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />

            <button type="submit">Register</button>
          </form>
        </div>
        <OrDivider />
        <OAuthButton
          label="Sign up with GitHub"
          logo="/github-mark.svg"
          onClick={() => window.location.href = `${config.apiBaseUrl}${config.basePath}/auth/github/login`}
        />
        <OAuthButton
          label="Sign up with Gitea"
          logo="/gitea-svgrepo-com.svg"
          onClick={() => window.location.href = `${config.apiBaseUrl}${config.basePath}/auth/gitea/login`}
        />
        <div className="login-redirect">
          <span>Already have an account?</span>
          <a href="/login"> Sign in here</a>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
